import BulmaTagsInput from '@creativebulma/bulma-tagsinput';
import '@creativebulma/bulma-tagsinput/dist/js/bulma-tagsinput.js'

function syncParcelCodesCounter(input) {
  const modal = input.closest("[data-parcel-scanner-modal]");
  const counter = modal?.querySelector("[data-parcel-codes-count]");
  if (!counter) return;

  counter.textContent = input.value.split(",").filter((value) => value.trim().length > 0).length;
}

function attachTagsInput() {
  BulmaTagsInput.attach();

  document.querySelectorAll('[data-parcel-scanner-modal] input[data-type="tags"]').forEach((input) => {
    syncParcelCodesCounter(input);

    if (input.dataset.parcelCodesCounterAttached === "true") return;

    input.addEventListener("change", () => syncParcelCodesCounter(input));
    input.dataset.parcelCodesCounterAttached = "true";
  });
}

document.addEventListener("DOMContentLoaded", attachTagsInput);
document.addEventListener("turbo:load", attachTagsInput);
